




































import { Component, InjectReactive, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import TitleMixin from '@/mixins/title-mixin';
import FeedTankCorrectionsList from './components/corrections/FeedTankCorrectionsList.vue';
import FeedTankCorrectionAdd from './components/corrections/FeedTankCorrectionAdd.vue';
import FeedTankCorrectionSettings from './components/corrections/FeedTankCorrectionSettings.vue';
import { Correction, FeedCorrection, FeedTank } from '@/api';
import { ref } from 'vue';

@Component({
	components: {
		FeedTankCorrectionAdd,
		FeedTankCorrectionsList,
		FeedTankCorrectionSettings,
	},
})
export default class FeedTankCorrections extends mixins(TitleMixin) {
	@InjectReactive('selectedFeedTank')
	public feedTank!: FeedTank & { corrections: Correction[] };

	public savedCorrections: FeedCorrection[] = [];

	public parameters: Record<string, string | number | null> = {};
	public correction: Record<string, number | null> = {};

	public correctionsList?: FeedTankCorrectionsList;

	@Watch('feedTank')
	public created(): void {
		setTimeout(() => {
			this.correctionsList = <FeedTankCorrectionsList>this.$refs.correctionsList;
		}, 1);

		this.parameters = <Record<string, string | number>>this.feedTank.formulaParameters;
		this.correction = {};
		Object.keys(this.parameters).forEach(key => {
			this.correction[key] = (<any>this.feedTank?.formulaCorrection ?? { [key]: 0 })[key] ?? 0;
		});
	}

	public async reloadCorrectionList(
		correctionsSettings?: FeedTankCorrectionSettings,
		reloadFromApi: boolean = false,
	): Promise<void> {
		await this.correctionsList?.loadCorrections(reloadFromApi);

		await correctionsSettings?.updateTank();
	}
}
